'use strict';
import { merge } from 'merge-anything';

/**
 * @class TcmsBaseClass
 *
 */
export class TcmsBaseClass {

    constructor() {
    }

    /**
     * @description Shallow Copy of 2 objects. Returns a new object. Duplicate props will be overwriten by target
     *
     * @param {Object} source
     * @param {Object} target
     *
     * @returns {Object}
     */
    mergeObject(source = {}, target = {}): {} {
        return merge(source, target);
    }

}

export interface TcmsBaseClassInterface extends TcmsBaseClass {
}
